import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "../../assets/img/profileLogo.png";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomDateField from "components/UpdateUi/CustomDateField";
import axios from "axios";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { endpoint } from "assets/api/endpoint";
import ToastModal from "views/components/ToastModal";
import { saveAuthData, saveUserData } from "store/reducers/login/LoginSlice";
import { useDispatch } from "react-redux";
import { idNumberDocumentsList } from "assets/properties/properties";
import { formatTime } from "utils/Utils";
import { apiHandler } from "assets/api";
import loginBg from "../../assets/img/login_bg.png";
import brandTheme from "brandTheme/Theme";
import { parseAndSetFlag } from "utils/Utils";
import ConsentSection from "./ConsentSection";
import { saveAdminPortalData } from "store/reducers/login/LoginSlice";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
      display: "flex",
  // height: "calc(100vh - 130px)",
  overflowY: "auto",

  backgroundImage: `
    linear-gradient(
      rgba(43,0,19,0.25),
      rgba(91,0,44,0.25)
    ),
    url(${loginBg})
  `,
  height:"100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
       height: "auto",
    minHeight: "100vh",
    },
  },

  // LEFT SIDE
  leftSection: {
    flex: 1,
    padding: "150px 70px 0px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",


    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },

  // logo: {
  //   width: "180px",
  //   marginBottom: "50px",
  // },

  heroTitle: {
    fontSize: "68px",
    fontWeight: 700,
    lineHeight: 1.15,
    marginBottom: "24px",
    color: "#fff",
  },

  heroSubTitle: {
    fontSize: "19px",
    lineHeight: 1.8,
    maxWidth: "560px",
    color: "#F5E1E8",
  },

  featureRow: {
    display: "flex",
    gap: "50px",
    marginTop: "60px",
  },

  featureItem: {
    textAlign: "center",

    "& span": {
      fontSize: "38px",
      display: "block",
      marginBottom: "12px",
    },

    "& p": {
      margin: 0,
      color: "#fff",
      fontSize: "15px",
      fontWeight: 500,
    },
  },

  // RIGHT SIDE
  rightSection: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px 24px",
  },

  formBox: {
    width: "100%",
    maxWidth: "520px",

    background: "rgba(255,255,255,0.97)",

    backdropFilter: "blur(12px)",

    borderRadius: "32px",

    padding: "50px 42px",

    boxShadow: "0 30px 80px rgba(0,0,0,0.22)",

    border: "1px solid rgba(255,255,255,0.2)",

    [theme.breakpoints.down("sm")]: {
      padding: "35px 24px",
    },
  },

  avatarBox: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "22px",
  },

  avatar: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    border: "4px solid #F4E4EA",
    objectFit: "cover",
  },

  heading: {
    fontSize: "38px",
    fontWeight: 700,
    color: brandTheme.mainColor,
    textAlign: "center",
    marginBottom: "10px",
    '@media (max-width:600px)':{
          fontSize: "30px",
    },
  },

  subHeading: {
    textAlign: "center",
    color: "#777",
    marginBottom: "36px",
    fontSize: "15px",
  },

  flexRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "24px",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },

  inputField: {
    width: "100%",
  },

  selectBox: {
    minWidth: "90px",
  },

  documentSelectBox: {
    minWidth: "150px",
  },

  identityOptions: {
    display: "flex",
    gap: "14px",
    marginBottom: "24px",
  },

  identityButton: {
    flex: 1,
    height: "54px",
    borderRadius: "14px",
    border: `1px solid ${brandTheme.mainColor}`,
    background: "#fff",
    color: brandTheme.mainColor,
    fontWeight: 700,
    cursor: "pointer",
    transition: "0.3s",
    fontSize: "15px",
  },

  activeButton: {
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",

    color: "#fff",

    border: "none",

    boxShadow: "0 10px 24px rgba(91,0,44,0.22)",
  },

  button: {
    marginTop: "30px",

    height: "60px",

    borderRadius: "16px",
    width:'100%',
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",

    color: "#fff",

    fontWeight: 700,

    fontSize: "17px",

    textTransform: "none",

    boxShadow: "0 12px 28px rgba(21, 37, 79, 0.28)",

    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    },
  },
  resendText:{
    textDecoration:'underline',
    cursor:'pointer'
  }
}));

const LoginPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [identityType, setIdentityType] = useState("dob");
  const [dob, setDob] = useState("");
  const [pan, setPan] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [documentType, setDocumentType] = useState(
    idNumberDocumentsList?.[0]?.value
  );
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [userExistApi, setUserExistApi] = useState(false);
  const [mfaToken, setMfaToken] = useState(false);
  const [resendTimer, setResendTimer] = useState(120);
  const [showResendOption, setShowResendOption] = useState(false);
  const [resendOtpTimer, setResendOtpTimer]= useState(false)
  const [isSignup, setIsSignup] = useState(false);
  const [partnerLeadParams, setPartnerLeadParams] = useState(null);
  const [newCustomer,setNewCustomer] = useState(false);
  const dispatch = useDispatch();
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const repaymentFlag = sessionStorage.getItem("RepaymentFlag");
  const [consent, setConsent] = useState({
  terms: true,
  communication: true,
  ckyc: true,
});
  useEffect(() => {
    let timer;
    if (userExistApi || resendOtpTimer) {
      setResendTimer(120); // Reset the timer on every new OTP screen
      setShowResendOption(false); // Hide resend initially
      setResendOtpTimer(false)
      timer = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setShowResendOption(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer); // Cleanup on unmount or update
  }, [userExistApi, resendOtpTimer]);
  useEffect(() => {
    const storedPartnerParams = sessionStorage.getItem("partnerLeadParams");
    if (storedPartnerParams) {
      try {
        setPartnerLeadParams(JSON.parse(storedPartnerParams));
      } catch (error) {
        console.error("Invalid partner lead params", error);
        sessionStorage.removeItem("partnerLeadParams");
      }
    }
  }, []);
  const validateQueryParams = () => {
    let query = "&";
    if (dob) {
      query += `dob=${dob}`;
    } else if (idNumber) {
      query += `pan=${idNumber.toUpperCase()}`;
    }
    return query;
  };
  const handleLoginSubmit = async () => {
    try {
      if (mobileNumber.length < 10) {
        toastUpdate("Error", "Fill all the data", true);
        return;
      }
      setCallInProgress(true);
      const queryParams = validateQueryParams();
      const mobileStatusUrl = `${endpoint.BASE_URL_STAGING}/${endpoint.CHECK_USER_DETAILS}${mobileNumber}`;
      console.log(mobileStatusUrl, "API URL");

      // First API call: Check mobile status
      const response = await axios.get(mobileStatusUrl);
      setCallInProgress(false);

      if (response?.data?.error_code || response?.data?.error) {
        toastUpdate(
          "Error",
          response?.data?.user_description || response?.data?.error_description,
          true
        );
        return;
      }

      console.log(response, "API Response");

      if (response?.data?.status !== "EXIST") {
        setNewCustomer(true);
        // User does not exist, proceed to sign-up
        const signUpUrl = `${endpoint.BASE_URL_STAGING}/${endpoint.USER_SIGN_UP_API}`;
        console.log(signUpUrl, "Sign-up API URL");

        try {
          const signUpResponse = await axios.post(signUpUrl, {
            mobileNumber: mobileNumber,
          });

          if (signUpResponse?.data?.error_code || signUpResponse?.data?.error) {
            toastUpdate(
              "Error",
              signUpResponse?.data?.user_description ||
                signUpResponse?.data?.error_description,
              true
            );
            return;
          }
        } catch (signUpError) {
          console.error("Sign-up API Error:", signUpError);
          toastUpdate("Error", "Sign-up failed. Please try again.", true);
          return;
        }
      }
      try {
      setCallInProgress(true);
        const loginUrl = `${endpoint.BASE_URL_STAGING}/${endpoint.USER_LOGIN_API}`;
        console.log(loginUrl, "Login API URL");

        const loginResponse = await axios.post(loginUrl, {
          username: mobileNumber,
        });
      setCallInProgress(false);

        if (loginResponse?.data?.mfa_token) {
          setMfaToken(loginResponse?.data?.mfa_token);
        }
      } catch (loginError) {
        console.error("Login API Error:", loginError);
        toastUpdate("Error", "Login failed. Please try again.", true);
        return;
      }

      // Navigate to OTP page
      setUserExistApi(true);
    } catch (error) {
      setCallInProgress(false);
      console.error("API Error:", error);
      toastUpdate("Error", "Something went wrong. Please try again.", true);
    }
  };

  const handleOtpLoginSubmit = async () => {
    try {
      const validateOtp = await axios.post(
        endpoint.BASE_URL_STAGING + "/" + endpoint.VALIDATE_OTP_API,
        {
          username: mobileNumber,
          token: mfaToken,
          otp: otpCode,
        }
      );
      if (validateOtp?.data?.error_code) {
        toastUpdate("Error", validateOtp?.data?.user_description, true);
      } else {
        const accessToken = validateOtp?.data?.access_token;
        dispatch(
          saveAuthData({
            authToken: validateOtp?.data.access_token,
            refreshToken: validateOtp?.data.refresh_token,
            tokenTime: Date.now(),
            isAuthenticated: true,
          })
        );
        dispatch(
          saveUserData({
            role: validateOtp?.data?.role ? validateOtp?.data?.role : "",
            username: validateOtp?.data?.username
              ? validateOtp?.data?.username
              : "",
            email: validateOtp?.data?.email ? validateOtp?.data?.email : "",
            name: validateOtp?.data?.name ? validateOtp?.data?.name : "",
            mobileNumber: validateOtp?.data?.mobile_number
              ? validateOtp?.data?.mobile_number
              : "",
          })
        );
        dispatch(
          saveAdminPortalData({
            enabled: false,
          })
        );
        const storedPartnerParams =
          sessionStorage.getItem("partnerLeadParams");
        if (storedPartnerParams) {
          try {
            const partnerParams = JSON.parse(storedPartnerParams);
            console.log(
              "Partner lead params found:",
              partnerParams
            );
            setCallInProgress(true);
          
            const partnerResponse = await apiHandler({
              url: endpoint.PARTNER_LEADS_API,
              method: "POST",
              authToken: accessToken,
              data: {
                partnerId: partnerParams?.partner_id,
                product: partnerParams?.product,
                leadRef: partnerParams?.lead_ref,
                channel: partnerParams?.channel,
                mobileNumber: validateOtp?.data?.mobile_number,
                newCustomer: newCustomer,
              },
            });
          
            setCallInProgress(false);
          
            console.log(
              "Partner API response:",
              partnerResponse
            );
          
            // Remove it so it doesn't execute again
            sessionStorage.removeItem("partnerLeadParams");
          
          } catch (partnerError) {
            setCallInProgress(false);
          
            console.error(
              "Partner API Error:",
                partnerError
            );
          
            toastUpdate(
              "Error",
              "Partner lead processing failed.",
              true
            );
          
            return;
          }
        }
        setCallInProgress(true);
        const result = await apiHandler({
          url:
            endpoint.GET_USER_PAN_DETAILS_API +
            validateOtp?.data?.mobile_number,
          authToken: validateOtp?.data.access_token,
        });
        setCallInProgress(false);
        if (
          result?.data?.panNumber &&
          result?.data?.panNumber !== "" &&
          result?.data?.panNumber !== null
        ) {
          if(parseAndSetFlag(repaymentFlag)){
            navigate("/repayment", { replace: true });
          }else{
            navigate("/dashboard", { replace: true });
          }
        } else {
          navigate("/panDetails", { replace: true });
        }
      }
    } catch (validateOtpError) {
      setCallInProgress(false);
      console.error("API Error:", validateOtpError);
      toastUpdate("Error", "Something went wrong. Please try again.", true);
    }
  };
  const handleResendOtp = async () => {
    try {
      const validateOtp = await axios.put(
        endpoint.BASE_URL_STAGING + "/" + endpoint.RESEND_OTP_API,
        {},
        {
          headers: {
            Authorization: "Bearer " + mfaToken,
          },
        }
      );

      if (validateOtp?.data?.error_code) {
        toastUpdate("Error", validateOtp?.data?.user_description, true);
      } else {
        toastUpdate("Success", "Otp sent successfully", true);
        setResendTimer(120);
        setShowResendOption(false);
        setResendOtpTimer(true)
      }
    } catch (validateOtpError) {
      setCallInProgress(false);
      console.error("API Error:", validateOtpError);
      toastUpdate("Error", "Something went wrong. Please try again.", true);
    }
  };
  return (
    <div className={classes.mainContainer}>

      {/* LEFT SECTION */}
      <div className={classes.leftSection}>
        <Typography className={classes.heroTitle}>
          Fast & Easy <br />
          Personal Loans
        </Typography>

        <Typography className={classes.heroSubTitle}>
          Get instant approval, flexible EMI options and
          low-interest rates with our modern financial
          platform.
        </Typography>

        <div className={classes.featureRow}>
          <div className={classes.featureItem}>
            <span>🛡️</span>
            <p>100% Secure</p>
          </div>

          <div className={classes.featureItem}>
            <span>⚡</span>
            <p>Instant Approval</p>
          </div>

          <div className={classes.featureItem}>
            <span>₹</span>
            <p>Low Interest</p>
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className={classes.rightSection}>
        <div className={classes.formBox}>
          <div className={classes.avatarBox}>
            <img
              src={logo}
              alt="profile"
              className={classes.avatar}
            />
          </div>

          <Typography className={classes.heading}>
  {isSignup ? "Create Your Account" : "Welcome Back"}
</Typography>

<Typography className={classes.subHeading}>
  {isSignup
    ? "Sign up using your mobile number."
    : "Sign in to continue."}
</Typography>
        {userExistApi ? (
          <>
            <CustomTextField
              label="OTP Code"
              placeholder="Enter 4 digit code"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value)}
              style={classes.inputField}
              maxLength={4}
              type="number"
            />
            <div>
              {showResendOption ? (
                <div style={{display:'flex', gap:'10px'}}>
                  <p>{`Didn't get the OTP?`}</p>
                  <p onClick={handleResendOtp} className={classes.resendText}>
                    {`Resend OTP`}
                  </p>
                </div>
              ) : (
                <p>{`You can resend OTP in ${formatTime(resendTimer)}`}</p>
              )}
            </div>

            <Button className={classes.button} onClick={handleOtpLoginSubmit}>
  {isSignup ? "Verify & Sign Up" : "Verify & Sign In"}
</Button>
          </>
        ) : (
          <>
            <div className={classes.flexRow}>
              <CustomSelect
                label="Code"
                value={countryCode}
                onChange={(e) => setCountryCode(e.target.value)}
                options={[{ value: "+91", label: "+91" }]}
                style={classes.selectBox}
              />
              <CustomTextField
                label="Mobile Number"
                placeholder="Mobile Number"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                style={classes.inputField}
                maxLength={10}
                type="number"
              />
            </div>
            {!parseAndSetFlag(repaymentFlag) &&
              <ConsentSection setConsent={setConsent} consent={consent}/>
            }
            <Button className={classes.button} 
              onClick={handleLoginSubmit} 
              disabled={
                !consent.terms ||
                !consent.communication ||
                !consent.ckyc
              }>
  {isSignup ? "Sign Up" : "Sign In"}
</Button>
<div
  style={{
    textAlign: "center",
    marginTop: "18px",
    fontSize: "15px",
  }}
>
  {isSignup ? (
    <>
      Already have an account?{" "}
      <span
        style={{
          color: brandTheme.mainColor,
          fontWeight: 600,
          cursor: "pointer",
        }}
        onClick={() => setIsSignup(false)}
      >
        Sign In
      </span>
    </>
  ) : (
    <>
      {!parseAndSetFlag(repaymentFlag) && (
        <>
          {"Don't have an account?"}
          <span
            style={{
              color: brandTheme.mainColor,
              fontWeight: 600,
              cursor: "pointer",
            }}
            onClick={() => setIsSignup(true)}
          >
            {" "}Sign Up
          </span>
        </>
      )}
    </>
  )}
</div>
          </>
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
    {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;